import { render, staticRenderFns } from "./CardexpPhone.vue?vue&type=template&id=4b09f586&"
import script from "./CardexpPhone.vue?vue&type=script&lang=js&"
export * from "./CardexpPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports